module.exports = [
  {
    token: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
    name: "BAT (BAT)",
  },
  {
    token: "0xB8c77482e45F1F44dE1745F52C74426C631bDD52",
    name: "BNB (BNB)",
  },
  {
    token: "0xcb97e65f07da24d46bcdd078ebebd7c6e6e3d750",
    name: "Bytom (BTM)",
  },
  {
    token: "0x514910771af9ca656af840dff83e8264ecf986ca",
    name: "ChainLink Token (LINK)",
  },
  {
    token: "0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359",
    name: "Dai Stablecoin v1.0 (DAI)",
  },
  {
    token: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
    name: "Decentraland (MANA)",
  },
  {
    token: "0xe5dada80aa6477e85d09747f2842f7993d0df71c",
    name: "Dock (DOCK)",
  },
  {
    token: "0x4ecdb6385f3db3847f9c4a9bf3f9917bb27a5452",
    name: "EKT (EKT)",
  },
  {
    token: "0xbf2179859fc6d5bee9bf9158632dc51678a4100e",
    name: "ELF (ELF)",
  },
  {
    token: "0x8e1b448ec7adfc7fa35fc2e885678bd323176e34",
    name: "Egretia (EGT)",
  },
  {
    token: "0x1d287cc25dad7ccaf76a26bc660c5f7c8e2a05bd",
    name: "Fetch (FET)",
  },
  {
    token: "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
    name: "HoloToken (HOT)",
  },
  {
    token: "0x6f259637dcd74c767781e37bc6133cd6a68aa161",
    name: "HuobiToken (HT)",
  },
  {
    token: "0xb5a5f22694352c15b00323844ad545abb2b11028",
    name: "ICON (ICX)",
  },
  {
    token: "0xfa1a856cfa3409cfa145fa4e20eb270df3eb21ab",
    name: "IOSToken (IOST)",
  },
  {
    token: "0x17aa18a4b64a55abed7fa543f2ba4e91f2dce482",
    name: "Insight Chain (INB)",
  },
  {
    token: "0x039b5649a59967e3e936d7471f9c3700100ee1ab",
    name: "Kucoin Shares (KCS)",
  },
  {
    token: "0xdd974d5c2e2928dea5f71b9825b8b646686bd200",
    name: "KyberNetwork (KNC)",
  },
  {
    token: "0x8971f9fd7196e5cee2c1032b50f656855af7dd26",
    name: "Lambda (LAMB)",
  },
  {
    token: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
    name: "Maker (MKR)",
  },
  {
    token: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
    name: "Matic Token (MATIC)",
  },
  {
    token: "0x8e766f57f7d16ca50b4a0b90b88f6468a09b0439",
    name: "Maximine Coin (MXM)",
  },
  {
    token: "0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26",
    name: "Measurable Data Token (MDT)",
  },
  {
    token: "0xF433089366899D83a9f26A773D59ec7eCF30355e",
    name: "Metal (MTL)",
  },
  {
    token: "0xa974c709cfb4566686553a20790685a47aceaa33",
    name: "Mixin (XIN)",
  },
  {
    token: "0x51db5ad35c671a87207d88fc11d593ac0c8415bd",
    name: "Moeda Loyalty Points (MDA)",
  },
  {
    token: "0x5d65D971895Edc438f465c17DB6992698a52318D",
    name: "Nebulas (NAS)",
  },
  {
    token: "0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206",
    name: "Nexo (NEXO)",
  },
  {
    token: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
    name: "OmiseGO (OMG)",
  },
  {
    token: "0xeb9a4b185816c354db92db09cc3b50be60b901b6",
    name: "OriginSport Token (ORS)",
  },
  {
    token: "0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664",
    name: "QuarkChain Token (QKC)",
  },
  {
    token: "0x408e41876cccdc0f92210600ef50372656052a38",
    name: "Republic (REN)",
  },
  {
    token: "0x1985365e9f78359a9B6AD760e32412f4a445E862",
    name: "Reputation (REP)",
  },
  {
    token: "0xb1eef147028e9f480dbc5ccaa3277d417d1b85f0",
    name: "SeeleToken (Seele)",
  },
  {
    token: "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
    name: "StatusNetwork (SNT)",
  },
  {
    token: "0xdac17f958d2ee523a2206206994597c13d831ec7",
    name: "Tether USD (USDT)",
  },
  {
    token: "0xd850942ef8811f2a866692a623011bde52a462c1",
    name: "VeChain (VEN)",
  },
  {
    token: "0xe41d2489571d322189246dafa5ebde1f4699f498",
    name: "ZRX (ZRX)",
  },
  {
    token: "0x05f4a42e251f2d52b8ed15e9fedaacfcef1fad27",
    name: "Zilliqa (ZIL)",
  },
]
